import { render, staticRenderFns } from "./persona.vue?vue&type=template&id=68eac28f&scoped=true"
import script from "./persona.vue?vue&type=script&lang=js"
export * from "./persona.vue?vue&type=script&lang=js"
import style0 from "./persona.vue?vue&type=style&index=0&id=68eac28f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68eac28f",
  null
  
)

export default component.exports